import React from "react";
import UpThere from "./components/navbar.js"
import {
    BrowserRouter as Router,
    Routes,
    Route, 
    useLocation 
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import Home from "./pages";
import XmlFormatter from "./pages/XmlFormatter.js";
import JsonFormatter from "./pages/JsonFormatter.js";
import HttpBasicAuthentication from "./pages/HttpBasicAuthentication.js";
import Base64EnDecode from "./pages/Base64EnDecode.js";
import UrlEnDecode from "./pages/UrlEnDecode.js";
import UnixTimestamp from "./pages/UnixTimestamp.js";
import SendPlainTextEmail from "./pages/SendPlainTextEmail.js";
import About from "./pages/About.js";
import NotFound from "./components/NotFound";


// Component to manage body class based on route
function BodyClass() {
    const location = useLocation();
  
    React.useEffect(() => {
      // Extract the pathname from location
      const { pathname } = location;
  
      // Update the body class based on the current route
      if (pathname === '/') {
        document.body.className = 'home-page';
      } else if (pathname === '/XML_Formatter') {
        document.body.className = 'xml-page';
      } else if (pathname === '/JSON_Formatter') {
        document.body.className = 'json-page';
      } else if (pathname === '/HTTP_Basic_Authentication') {
        document.body.className = 'http-page';
      } else if (pathname === '/BASE64_EnDecode') {
        document.body.className = 'base64-page';
      } else if (pathname === '/URL_EnDecode') {
        document.body.className = 'url-page';
      } else if (pathname === '/Unix_Timestamp') {
        document.body.className = 'unix-page';
      } else if (pathname === '/Send_Plain_Text_Email') {
        document.body.className = 'email-page';
      } else if (pathname === '/About') {
        document.body.className = 'about-page';
      }
    }, [location]);
  
    return null;
}

function App() {
    return (
        <Router>
            <BodyClass />
            <UpThere />
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/XML_Formatter" element={<XmlFormatter />} />
                <Route path="/JSON_Formatter" element={<JsonFormatter />} />
                <Route path="/HTTP_Basic_Authentication" element={<HttpBasicAuthentication />} />
                <Route path="/BASE64_EnDecode" element={<Base64EnDecode />} />
                <Route path="/URL_EnDecode" element={<UrlEnDecode />} />
                <Route path="/Unix_Timestamp" element={<UnixTimestamp />} />
                <Route path="/Send_Plain_Text_Email" element={<SendPlainTextEmail />} />
                <Route path="/About" element={<About />} />
                  <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}
 
export default App;